<template>
  <div class="result">
    <div class="title">{{ results[resultIndex].title }}</div>
    <div class="desc">{{ results[resultIndex].desc }}</div>
  </div>
</template>

<script>
export default {
  name: "ResultApp",
  props: ["results", "totalCorrect"],

  computed: {
    resultIndex() {
      let index = 0;

      this.results.forEach((currentItem, i) => {
        if (
          currentItem.min <= this.totalCorrect &&
          currentItem.max >= this.totalCorrect
        ) {
          index = i;
        }
      });
      return index;
    },
  },
};
</script>

<style></style>
